module.exports = __webpack_public_path__ + "img/13.9773d9dc.jpg";